// extracted by mini-css-extract-plugin
export default {"proFormCard":"hLbo954whAnzZvdR82mA","proFormCard_label":"f4QLaam9NvmT6pi11J5H","proFormCard_card":"KVT5Y67PiPWkY8lKsk4I"};